import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Card, Typography, Form, Input, Button, Space, Tag, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { getModerationStatusMinVersion } from '../../graphql/queries';
import { updateModerationStatusMinVersion } from '../../graphql/mutation';

const { Title, Paragraph, Text } = Typography;

const ModerationAppVersion = () => {
  const [minVersion, setMinVersion] = useState('');
  const [minVersionInput, setMinVersionInput] = useState('');

  const { data, loading, refetch } = useQuery(getModerationStatusMinVersion);
  const [updateMinVersionMutation, { loading: saving }] = useMutation(updateModerationStatusMinVersion);

  useEffect(() => {
    if (data?.getModerationStatusMinVersion !== undefined) {
      const v = data.getModerationStatusMinVersion ?? '';
      setMinVersion(v);
      setMinVersionInput(v);
    }
  }, [data]);

  const handleSave = async () => {
    try {
      await updateMinVersionMutation({ variables: { version: minVersionInput } });
      setMinVersion(minVersionInput);
      message.success('Moderation status min version updated');
      refetch();
    } catch (err) {
      message.error(err.message || 'Failed to update min version');
    }
  };

  return (
    <div style={{ maxWidth: 700 }}>
      <Title level={2} style={{ color: 'black' }}>Moderation App Version</Title>
      <Paragraph type="secondary">
        Moderation-rejected generations are stored as <Text code>MODERATION</Text>; app versions below this minimum still see them as <Text code>FAILED</Text>.
      </Paragraph>

      <Card loading={loading}>
        <Space align="center" style={{ marginBottom: 16 }}>
          <Text strong>Current minimum version:</Text>
          {minVersion ? <Tag color="blue">{minVersion}</Tag> : <Tag>Not set</Tag>}
        </Space>

        <Form layout="vertical" onFinish={handleSave}>
          <Form.Item
            label="Minimum App Version"
            extra="Versions at or above this see MODERATION; leave empty to hide it from everyone."
          >
            <Input
              value={minVersionInput}
              onChange={(e) => setMinVersionInput(e.target.value)}
              placeholder="e.g., 4.2.0"
              style={{ maxWidth: 300 }}
            />
          </Form.Item>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={handleSave}
            loading={saving}
            disabled={minVersionInput === minVersion}
          >
            Save
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default ModerationAppVersion;
